import { Button } from '../components_catalyst/button';
import { useAuth } from './AuthContext';
import { useState } from 'react';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../firebase';

export interface GoogleAuthButtonProps {
  mode: 'signin' | 'signup';
  onSuccess: (email: string) => void;
  onError: (error: Error) => void;
  disabled?: boolean;
}

export function GoogleAuthButton({ mode, onSuccess, onError, disabled }: GoogleAuthButtonProps) {
  const { signInWithGoogle } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleClick = async () => {
    setIsLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      onSuccess(result.user.email || '');
    } catch (error) {
      onError(error instanceof Error ? error : new Error('Failed to authenticate with Google'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      className="w-full border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 flex items-center justify-center gap-2"
      onClick={handleGoogleClick}
      disabled={isLoading || disabled}
    >
      {isLoading ? (
        'Loading...'
      ) : (
        <>
          <img src="/google.svg" alt="" className="w-5 h-5" aria-hidden="true" />
          <span>{mode === 'signin' ? 'Sign in with Google' : 'Sign up with Google'}</span>
        </>
      )}
    </Button>
  );
}
